// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3endW","modalForm":"UpgradeEpcsModal_modalForm__3R-21","modalFooter":"UpgradeEpcsModal_modalFooter__2JlEc"};